<template>
  <div class="password_img">
    <el-popover ref="popover" placement="right-start" trigger="focus">
      <p><i :class="newPass && $store.state.lengthPwd ? 'el-icon-circle-check c_abd' : 'el-icon-circle-close c_ece'"></i> 8-16位字符，密码不能是相同的用户名</p>
      <p><i :class="newPass && $store.state.iconPwd ? 'el-icon-circle-check c_abd' : 'el-icon-circle-close c_ece'"></i> 只能包含字母大小写、数字及特殊字符（除空格）</p>
      <p><i :class="newPass && $store.state.charsPwd ? 'el-icon-circle-check c_abd' : 'el-icon-circle-close c_ece'"></i> 字母大小写、数字及特殊字符至少包含两项</p>
    </el-popover>
    <el-input :type="flags" v-model="newPass" autocomplete="new-password" :placeholder="parentDate" @keydown.native="keydown($event)" v-popover:popover v-on:input="passInputRef" ></el-input>
    <el-image :src="imageUrl" class="image-eye" @click="pwdProtect"></el-image>
  </div>
</template>

<script>
export default {
  props: ["newPassWord", "msg", "parentDate"],
  data() {
    return {
      newPass: "",
      userName: "",
      flags: "password",
      imageUrl: require("@/assets/images/yanjing_bi.png"),
    }
  },
  watch: {
    msg: function (newData) {
      this.userName = newData
    }
  },
  methods: {
    pwdProtect() {
      if (this.flags == "password") {
        this.flags = 'text'
        this.imageUrl = require("@/assets/images/yanjing.png")
      } else {
        this.flags = 'password'
        this.imageUrl = require("@/assets/images/yanjing_bi.png")
      }
    },
    keydown(e){
      if(e.keyCode == 32){
        e.returnValue = false
      }
    },
    passInputRef(valPwd) {
      let degreeNumber = 0;
      if (valPwd == "" || valPwd.length < 8 || valPwd.length > 16 || valPwd == this.userName) {
        this.$store.state.lengthPwd = false
      } else {
        this.$store.state.lengthPwd = true
      }

      if (valPwd !== "") {
        this.$store.state.iconPwd = true;
      } else {
        this.$store.state.iconPwd = false;
      }

      let arrVerify = [
        {regName: 'Number', regValue: /^.*[0-9]+.*/},
        {regName: 'LowerCase', regValue: /^(?=.*?[A-Z])(?=.*?[a-z])*/},
        {regName: 'SpecialCharacters', regValue: /[\s+`!@#$%\^&\*_\-\+=\.]/g}
      ];
      let regNum = 0;// 记录匹配的次数
      for (let iReg = 0; iReg < arrVerify.length; iReg++) {
        if (arrVerify[iReg].regValue.test(valPwd)) {
          regNum = regNum + 1;
        }
      }
      degreeNumber = regNum;
      if (regNum <= 1) {
        this.$store.state.charsPwd = false;
      } else {
        this.$store.state.charsPwd = true;
      }

      this.$emit("listenToChildEvent", valPwd)
    },
  }
}
</script>

<style scoped>
.password_img {
  position: relative;
}
.password_img .image-eye {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/conPopover.vue